{
  "REPORT": {
    "HEADER": "Razgovori",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_AGENT_REPORTS": "Preuzmi izveštaj o agentima",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Ukupno )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Danas",
      "YESTERDAY": "Juče",
      "LAST_7_DAYS": "Poslednjih 7 dana",
      "LAST_30_DAYS": "Poslednjih 30 dana",
      "THIS_MONTH": "Овог месеца",
      "LAST_MONTH": "Прошлог месеца",
      "LAST_3_MONTHS": "Poslednja 3 meseca",
      "LAST_6_MONTHS": "Poslednjih 6 meseci",
      "LAST_YEAR": "Poslednja godina",
      "CUSTOM_DATE_RANGE": "Prilagođen opseg vremena"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Vrednost za grupisanje",
    "DURATION_FILTER_LABEL": "Trajanje",
    "GROUPING_OPTIONS": {
      "DAY": "Dan",
      "WEEK": "Nedelja",
      "MONTH": "Mesec",
      "YEAR": "Godina"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      },
      {
        "id": 2,
        "groupBy": "Nedelja"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      },
      {
        "id": 2,
        "groupBy": "Nedelja"
      },
      {
        "id": 3,
        "groupBy": "Mesec"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Dan"
      },
      {
        "id": 2,
        "groupBy": "Nedelja"
      },
      {
        "id": 3,
        "groupBy": "Mesec"
      }
    ],
    "BUSINESS_HOURS": "Radno vreme",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ništa nije pronađeno"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Razgovori: {count}",
      "RESULT_COUNT_MESSAGE": "Poruke: {count}",
      "EMPTY": "Nema zapisa za ovaj stubac.",
      "ERROR": "Zapisi nisu mogli da se učitaju. Pokušajte ponovo.",
      "LOAD_MORE": "Učitaj još",
      "PREVIOUS_BUCKET": "Prethodni stubac",
      "NEXT_BUCKET": "Sledeći stubac",
      "UNKNOWN_CONTACT": "Nepoznat kontakt",
      "UNKNOWN_INBOX": "Nepoznato prijemno sanduče",
      "UNASSIGNED_AGENT": "Nedodeljeno",
      "NO_MESSAGE_CONTENT": "Poruka nema sadržaj",
      "MESSAGE_CREATED_AT": "Poruka kreirana {time}",
      "EVENT_OCCURRED_AT": "Događaj se desio {time}",
      "INCOMING_MESSAGE": "Dolazna poruka",
      "OUTGOING_MESSAGE": "Odlazna poruka",
      "VIEW_ALL": "Prikaži u razgovorima",
      "VIEW_ALL_LIMIT": "U listi razgovora otvaraju se samo stubci sa najviše {limit} razgovora.",
      "HIDDEN_COUNT": "Nije prikazano jer niste član njihovog prijemnog sandučeta: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Pregled agenata",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_AGENT_REPORTS": "Preuzmi izveštaj o agentima",
    "FILTER_DROPDOWN_LABEL": "Izaberi agenta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Pregled oznaka",
    "DESCRIPTION": "Пратите учинак ознака помоћу кључних метрика, укључујући разговоре, време одговора, време решавања и решене случајеве.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_LABEL_REPORTS": "Preuzmi izveštaj o oznakama",
    "FILTER_DROPDOWN_LABEL": "Izaberi oznaku",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Pregled prijemnih sandučića",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_INBOX_REPORTS": "Preuzmi izveštaj o prijemnim sandučićima",
    "FILTER_DROPDOWN_LABEL": "Izaberi prijemno sanduče",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Pregled tima",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Učitavanje podataka grafikona...",
    "NO_ENOUGH_DATA": "Nismo primili dovoljno podataka da bi smo generisali izveštaj, Molim vas pokušajte ponovo.",
    "DOWNLOAD_TEAM_REPORTS": "Preuzmi izveštaj o timu",
    "FILTER_DROPDOWN_LABEL": "Izaberi tim",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Razgovori",
        "DESC": "( Ukupno )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Dolazne poruke",
        "DESC": "( Ukupno )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odlazne poruke",
        "DESC": "( Ukupno )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Vreme prvog odgovora",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme prvog odgovora je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Vreme rešavanja",
        "DESC": "( Prosečno )",
        "INFO_TEXT": "Ukupan broj razgovora korišćen za izračunavanje:",
        "TOOLTIP_TEXT": "Vreme rešenja je {metricValue} (zasnovano na {conversationCount} razgovora)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Broj rešenih",
        "DESC": "( Ukupno )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Poslednjih 7 dana"
      },
      {
        "id": 1,
        "name": "Poslednjih 30 dana"
      },
      {
        "id": 2,
        "name": "Poslednja 3 meseca"
      },
      {
        "id": 3,
        "name": "Poslednjih 6 meseci"
      },
      {
        "id": 4,
        "name": "Poslednja godina"
      },
      {
        "id": 5,
        "name": "Prilagođen opseg vremena"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Primeni",
      "PLACEHOLDER": "Izaberite opseg vremena"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Izveštaji zadovoljstva korisnika",
    "NO_RECORDS": "Nema dostupnih odgovora o zadovoljstvu korisnika.",
    "DOWNLOAD": "Preuzmite izveštaje o zadovoljstvu korisnika",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Izaberite agente"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Dodeljeni agent",
        "RATING": "Ocena",
        "FEEDBACK_TEXT": "Komentar povratne informacije"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Ukupno odgovora",
        "TOOLTIP": "Ukupan broj prikupljenih odgovora"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Ocena zadovoljstva",
        "TOOLTIP": "Ukupan broj pozitivnih odgovora / Ukupan broj odgovora * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Procenat odgovora",
        "TOOLTIP": "Ukupan broj odgovora / Ukupan broj poruka o zadovoljstvu korisnika * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Broj razgovora",
        "TOOLTIP": "Ukupan broj razgovora sa porukama bota"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Broj odgovora",
        "TOOLTIP": "Ukupan broj izlaznih poruka"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Broj AI odgovora",
        "TOOLTIP": "Ukupan broj poruka sa odgovorima koje je poslao bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Broj pripremljenih odgovora",
        "TOOLTIP": "Ukupan broj kopilot predloga koje je bot pripremio za agente"
      },
      "SUCCESS_RATE": {
        "LABEL": "Rešeno od strane AI",
        "TOOLTIP": "Procenat razgovora koje je rešio AI bez prosleđivanja agentu"
      },
      "RESOLVE_TIME": {
        "LABEL": "Vreme rešavanja",
        "TOOLTIP": "Medijalno vreme od prve poruke klijenta do poslednje poruke bota/agenta"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Ne grupiši",
      "INBOXES": "Sandučad",
      "LABELS": "Oznake"
    },
    "GROUPED": {
      "CHART_TITLE": "Raspodela po grupi",
      "BACK_TO_ALL": "Prikaži sve",
      "TABLE": {
        "INBOX": "Sanduče",
        "LABEL": "Oznaka",
        "CONVERSATIONS": "Razgovori",
        "MESSAGES": "Poruke",
        "MESSAGES_TOOLTIP": "Ukupan broj izlaznih poruka",
        "AI_MESSAGES": "AI odgovori",
        "AI_MESSAGES_TOOLTIP": "Ukupan broj AI odgovora, praćen brojem pozitivnih i negativnih ocena krajnjih korisnika",
        "THUMBS_UP_TOOLTIP": "Broj AI odgovora koje su krajnji korisnici ocenili pozitivno (palac gore)",
        "THUMBS_DOWN_TOOLTIP": "Broj AI odgovora koje su krajnji korisnici ocenili negativno (palac dole)",
        "PREPARED": "Pripremljeni odgovori",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Procenat poruka iz svih poruka koje pripadaju ovoj grupi",
        "BOT_RESPONSES": "AI odgovori %",
        "SUGGESTION_USED": "Korišćeni odgovori",
        "SUGGESTION_USED_TOOLTIP": "Procenat pripremljenih odgovora u ovoj grupi koje su agenti koristili",
        "SUGGESTION_NOT_USED": "Nekorišćeni odgovori",
        "SUGGESTION_NOT_USED_TOOLTIP": "Procenat poruka u ovoj grupi koje su imale pripremljen odgovor koji nije korišćen"
      },
      "NOTES": {
        "TITLE": "Kako se izračunavaju metrike",
        "CONVERSATIONS": "Broj razgovora koji imaju najmanje jednu izlaznu poruku u izabranom periodu.",
        "MESSAGES": "Ukupan broj izlaznih (ne-privatnih) poruka poslatih u izabranom periodu. Ovo uključuje i poruke koje je generisao AI i one koje su napisali ljudi.",
        "PERCENTAGE": "Udeo poruka ove grupe u ukupnom broju izlaznih poruka svih grupa.",
        "AI_MESSAGES": "Broj izlaznih poruka koje je automatski poslao AI bot (ne uključujući pripremljene odgovore za agente). Brojevi u zagradi pokazuju koliko je tih odgovora ocenjeno pozitivno (palac gore) i negativno (palac dole) od strane krajnjih korisnika.",
        "PREPARED": "Broj kopilot predloga (pripremljenih odgovora) koje je AI bot generisao za agente u izabranom periodu. Ovo su privatne poruke vidljive samo agentima i ne računaju se kao izlazne poruke, tako da se ovaj broj možda neće poklapati sa kolonom Poruke.",
        "SUGGESTION_USED": "Procenat pripremljenih odgovora u ovoj grupi koje su agenti koristili. Ovo se možda neće poklapati sa brojem u koloni Pripremljeni odgovori jer može uključivati i predloge generisane u prethodnim periodima.",
        "SUGGESTION_NOT_USED": "Procenat izlaznih poruka u ovoj grupi kod kojih je kopilot predlog bio dostupan, ali je agent odgovorio bez njegovog korišćenja. Broji se samo kada je agent zaista poslao odgovor. Ovo se možda neće poklapati sa brojem u koloni Pripremljeni odgovori jer može uključivati i predloge generisane u prethodnim periodima."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Pregled",
    "LIVE": "Uživo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Otvoreni razgovori",
      "LOADING_MESSAGE": "Učitavanje metrike razgovora...",
      "OPEN": "Otvoreni",
      "UNATTENDED": "Nedodeljeni",
      "UNASSIGNED": "Nedodeljen",
      "PENDING": "Nerešen"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Razgovori prema agentima",
      "LOADING_MESSAGE": "Učitavanje metrike agenata...",
      "NO_AGENTS": "Nema razgovora po agentima",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otvoreni",
        "UNATTENDED": "Nedodeljeni",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Tim",
        "OPEN": "Otvoreni",
        "UNATTENDED": "Nedodeljeni",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Status agenta",
      "ONLINE": "Dostupan",
      "BUSY": "Zauzet",
      "OFFLINE": "Nedostupan"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ništa nije pronađeno",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Naziv agenta",
        "INBOXES": "Naziv prijemnog sandučeta",
        "LABELS": "Naziv oznake",
        "TEAMS": "Naziv tima"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Prijemno sanduče",
      "AGENTS": "Agent",
      "LABELS": "Oznaka",
      "TEAMS": "Tim"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Razgovor",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Међузбир",
    "NO_TEAM": "Без тима",
    "GROUP_BY_TEAMS": "Групиши по тимовима",
    "INBOX": "Prijemno sanduče",
    "AGENT": "Agent",
    "TEAM": "Tim",
    "LABEL": "Ознака",
    "TOTAL": "Ukupno",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Broj rešenih",
    "CONVERSATIONS": "Broj razgovora",
    "OUTGOING_CHATS": "Izlazni čatovi",
    "OUTGOING_EMAILS": "Izlazne e-poruke",
    "PHONE_CALLS": "Telefonski pozivi",
    "INBOUND_CALLS": "Dolazni pozivi",
    "OUTBOUND_CALLS": "Izlazni pozivi",
    "TOTAL_ACTIVITIES": "Ukupno aktivnosti",
    "ONLINE_TIME": "Vreme na mreži",
    "QUEUE_AVAILABLE_TIME": "Vreme dostupnosti u redu",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Broj izlaznih poruka koje je poslao ovaj agent",
      "OUTGOING_EMAILS": "Broj izlaznih e-poruka koje je poslao ovaj agent",
      "PHONE_CALLS": "Ukupan broj telefonskih poziva dodeljenih ovom agentu (zbir dolaznih i izlaznih poziva)",
      "TOTAL_ACTIVITIES": "Ukupan broj aktivnosti: dolazni pozivi + izlazni pozivi + izlazni čatovi + izlazne e-poruke",
      "INBOUND_CALLS": "Broj dolaznih telefonskih poziva dodeljenih ovom agentu",
      "OUTBOUND_CALLS": "Broj izlaznih telefonskih poziva dodeljenih ovom agentu",
      "AVG_FIRST_RESPONSE_TIME": "Prosečno vreme od kreiranja razgovora do prvog odgovora agenta u razgovorima dodeljenim ovom agentu",
      "AVG_RESOLUTION_TIME": "Prosečno vreme od kreiranja razgovora do rešavanja u razgovorima dodeljenim ovom agentu",
      "AVG_REPLY_TIME": "Prosečno vreme koje klijenti čekaju između svoje poruke i odgovora agenta u razgovorima dodeljenim ovom agentu",
      "ONLINE_TIME": "Ukupno vreme koje je agent bio na mreži ili zauzet tokom izabranog perioda",
      "QUEUE_AVAILABLE_TIME": "Ukupno vreme koje je agent bio dostupan u redovima čekanja tokom izabranog perioda"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Izveštaji o pozivima",
    "DESCRIPTION": "Pratite metrike telefonskih poziva sa detaljnim uvidom u dolazne i izlazne pozive, grupisane po agentu ili sandučetu radi sveobuhvatne analize.",
    "DOWNLOAD_PHONE_REPORTS": "Preuzmi izveštaje o pozivima",
    "GROUP_BY": {
      "LABEL": "Grupiši po",
      "AGENT": "Agent",
      "INBOX": "Sanduče"
    },
    "TABLE": {
      "TOTAL_CALLS": "Ukupno",
      "INBOUND_CALLS": "Dolazni",
      "OUTBOUND_CALLS": "Izlazni",
      "FAILED_OUTBOUND_CALLS": "Neuspeli izlazni",
      "AVG_AGENT_HANDLED_DURATION": "Prosečno trajanje",
      "TOTAL_AGENT_HANDLED_DURATION": "Ukupno trajanje",
      "AVG_RINGING_TIME": "Prosečno vreme zvonjenja",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Uspešnost %",
      "UNIQUE_CALLERS": "Jedinstveni pozivaoci",
      "UNIQUE_CALLED_CONTACTS": "Jedinstveni pozvani",
      "UNANSWERED_MISSED_CALLS": "Propušteno bez praćenja",
      "UNANSWERED_MISSED_PERCENTAGE": "Propušteno bez odgovora %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Propušteno bez praćenja, nedovoljno pozvano nazad",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Propušteno bez praćenja, nedovoljno pozvano nazad %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Ukupan broj svih poziva (uključujući nepovezane)",
      "INBOUND_CALLS": "Broj povezanih poziva",
      "OUTBOUND_CALLS": "Broj svih izlaznih poziva (uključujući nepovezane)",
      "FAILED_OUTBOUND_CALLS": "Broj izlaznih poziva koji nisu uspeli da se povežu",
      "AVG_AGENT_HANDLED_DURATION": "Prosečno trajanje poziva koje su obradili agenti",
      "TOTAL_AGENT_HANDLED_DURATION": "Ukupno trajanje svih poziva koje su obradili agenti",
      "AVG_RINGING_TIME": "Prosečno vreme zvonjenja poziva pre nego što se odgovori",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Procenat izlaznih poziva koji su uspešno povezani",
      "UNIQUE_CALLERS": "Broj jedinstvenih kontakata koji su uputili dolazne pozive",
      "UNIQUE_CALLED_CONTACTS": "Broj jedinstvenih kontakata koji su pozvani putem izlaznih poziva",
      "UNANSWERED_MISSED_CALLS": "Broj propuštenih poziva kod kojih nije izvršen uspešan povratni poziv (poziv povezan). Može uključivati pozive koji se još uvek mogu obraditi u toku radnog dana",
      "UNANSWERED_MISSED_PERCENTAGE": "Procenat jedinstvenih pozivalaca čiji su pozivi propušteni bez praćenja (propušteni pozivi bez odgovora / jedinstveni pozivaoci)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Broj propuštenih poziva sa manje od 2 pokušaja povratnog poziva. Može uključivati pozive koji se još uvek mogu obraditi u toku radnog dana",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Procenat jedinstvenih pozivalaca sa manje od 2 pokušaja povratnog poziva ((propušteno bez praćenja - dovoljno obrađeno) / jedinstveni pozivaoci)"
    }
  }
}
